module.exports = __webpack_public_path__ + "img/sponsor.1ec9a94f.png";